<template>
    <div>
        <b-navbar toggleable="md" type="light" variant="light">
            <b-navbar-toggle target="search_nav_collapse"></b-navbar-toggle>
            <b-collapse is-nav id="search_nav_collapse">
                <b-navbar-nav>
                    <b-nav-item class="item margin"
                                @click="getInvoicePayoffByTransactionType(5)"
                                :class="{active : status === 5}">
                        ทั้งหมด
                    </b-nav-item>
                    <b-nav-item class="item margin"
                                @click="getInvoicePayoffByTransactionType(3)"
                                :class="{active : status === 3}">
                        เงินสด
                    </b-nav-item>
                    <b-nav-item class="item margin"
                                @click="getInvoicePayoffByTransactionType(2)"
                                :class="{active : status === 2}">
                        เงินโอน
                    </b-nav-item>
                    <b-nav-item class="item margin"
                                @click="getInvoicePayoffByTransactionType(1)"
                                :class="{active : status === 1}">
                        เช็ค
                    </b-nav-item>
                    <b-nav-item class="item margin"
                                @click="getInvoicePayoffByTransactionType(4)"
                                :class="{active : status === 4}">
                        ยกเลิก
                    </b-nav-item>
                </b-navbar-nav>
                <b-navbar-nav class="ml-auto" v-on:keypress.enter.prevent="searchPayoff(1)">
                    <input type="text" v-model="search.customer"
                           placeholder="ค้นหาลูกค้า"
                           class="form-control col-2"/> &nbsp;
                    <input type="text" v-model="search.amount"
                           placeholder="ค้นหายอดเงิน"
                           class="form-control col-2"/> &nbsp;
                    <input type="text" class="form-control col-2"
                           placeholder="ค้นหาเลขที่ RV"
                           v-model="search.rv_number"/>&nbsp;
                    <b-form-select v-model="search.rv_status" :options="optionStatus" class="w-25">
                    </b-form-select>&nbsp;
                    <date-picker v-model="search.date"
                                 range
                                 placeholder="วันที่เริ่มต้น - วันที่สิ้นสุด"
                                 :format="changeFormat"
                                 :lang="lang"
                                 confirm>
                    </date-picker>
                    &nbsp;&nbsp;
                    <button class="btn btn-success my-2 my-sm-0"
                            @click="searchPayoff(1)"
                            type="button">
                        <icon name="search"></icon>
                        ค้นหา
                    </button>
                    &nbsp

                    <button class="btn btn-warning my-2 my-sm-0"
                            @click="onPayoff"
                            type="button">
                        <icon name="plus"></icon>
                        ตัดชำระ
                    </button>
                    &nbsp

                    <button class="btn btn-success my-2 my-sm-0"
                            @click="printPayoffwithSearch"
                            type="button">
                        <icon name="print"></icon>
                        รายงานบันทึกรับ(RV)
                    </button>
                    &nbsp
                    <button class="btn btn-success my-2 my-sm-0"
                            @click="printPayoffwithSearchDriver"
                            type="button">
                        <icon name="print"></icon>
                        รายงานบันทึกรับ(คนรถ)
                    </button>
                    &nbsp
                    <button class="btn btn-success my-2 my-sm-0"
                            @click="printCustomerOverpay"
                            type="button">
                        <icon name="print"></icon>
                        รายงานร้านค้าจ่ายเกิน
                    </button>
                </b-navbar-nav>
            </b-collapse>
        </b-navbar>
        <b-navbar toggleable="md">
            <b-navbar-toggle target="search_nav_collapse"></b-navbar-toggle>
            <b-navbar-nav class="mr-auto" v-on:keypress.enter.prevent="searchPayoff(1)">
                <!--search invoice-->
                <input type="text" v-model="search.invoice_id"
                       placeholder="ค้นหา TN"
                       class="form-control col-7"/>&nbsp;&nbsp;
                <!--search billing-->
                <input type="text" v-model="search.billing"
                       placeholder="ค้นหาเลขใบวางบิล"
                       class="form-control col-7"/>
            </b-navbar-nav>
            <span class="ml-auto" style="color: red; font-size: 15px;">**อนุมัติการตัดชำระ เฉพาะคุณมดเท่านั้น</span>
        </b-navbar>
        <div class="table-responsive" style="text-align: center">
            <table class="table table-bordered" id="table_payoff">
                <thead>
                <tr>
                    <th scope="col">เลขใบรับเงิน</th>
                    <!--                    <th scope="col">เลขใบ TN</th>-->
                    <th scope="col">วันที่ใบรับเงิน</th>
                    <th scope="col">ลูกค้า</th>
                    <th scope="col">เซลล์</th>
                    <th scope="col">ยอดเงินรวม</th>
                    <th scope="col">ช่องทางการชำระเงิน</th>
                    <th scope="col">สถานะ</th>
                    <th scope="col">วันที่บันทึกรับ</th>
                    <th scope="col">ผู้บันทึกแบบร่าง</th>
                    <th scope="col">ผู้บันทึกรับ</th>
                    <th scope="col" v-if="status!=4">ดูข้อมูล</th>
                    <th scope="col" v-if="status!=4">พิมพ์</th>
                    <th scope="col" v-if="status!=4">ยกเลิก</th>
                    <th scope="col" v-if="status==4">หมายเหตุ</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="data in InvoicePayoffList">
                    <td>
                        <template v-if="data.payoff_number">
                            {{ data.payoff_number }}
                        </template>
                        <template v-else>-</template>
                    </td>
                    <!--                    <td>-->
                    <!--                        <template v-if="data.details">-->
                    <!--                            <span v-for="tn in data.details[0]">-->
                    <!--                                {{tn.invoice.invoice_id}},-->
                    <!--                            </span>-->
                    <!--                        </template>-->
                    <!--                        <template v-if="data.invoice_payoff_details">-->
                    <!--                            <span v-for="(tn,index) in data.invoice_payoff_details[0]">-->
                    <!--                                <span v-if="index == 'onlyTN'">-->
                    <!--                                    {{tn}},-->
                    <!--                                </span>-->
                    <!--                            </span>-->
                    <!--                        </template>-->
                    <!--                    </td>-->
                    <td>{{ data.date | moment("DD/MM/YYYY") }}</td>
                    <td>
                        <template v-for="item in data.customer">
                            - {{ item ? item.customer_id : '-' }} - {{ item ? item.store_name : '-' }}<br>
                        </template>
                    </td>
                    <td>
                        <template v-if="data.sale">
                            {{ data.sale.sale_id }} - {{ data.sale.name }}
                        </template>
                        <template v-else>-</template>
                    </td>
                    <td>{{ data.amount | currency }}</td>
                    <td>
                        <template v-if="data.transactions.length > 0" v-for="transaction in data.transactions">
                            - {{ transaction.transaction_type.name }} <span
                            v-if="transaction.remark"><br>{{ transaction.remark }}</span>
                            {{ transaction.amount | currency }} บาท<br/>
                        </template>
                        <template v-else>-</template>
                    </td>
                    <td>
                        <template v-if="data.is_credit_customer">
                            <span style="color: grey">ตัดเครดิตเกิน</span>
                        </template>
                        <template v-else>
                            <template v-if="status==4">
                                <span style="color: blue">{{ data.payoff_status_name }}</span>
                                <span style="color: red"> (ยกเลิกแล้ว)</span>
                            </template>
                            <template v-else>
                                <template v-if="data.payoff_status_id">
                                    <span style="color: #00a699">{{ data.payoff_status_name }}</span>
                                </template>
                                <template v-else>
                                <span v-if="canViewSuperAdmin" class="for-delete"
                                      style="text-decoration: underline ;color: red">
                                    <a @click="goToPayoffForm(data , 2)" :id="'taga'+data.id">
                                        {{ data.payoff_status_name }}
                                    </a>
                                    <div style="display: none;margin-left: 25%" class="spinner-border spinner-border-xl"
                                         role="status" :id="'loading'+data.id"></div>
                                </span>
                                    <span v-else style="color: grey">
                                    <a>
                                        {{ data.payoff_status_name }}
                                    </a>
                                </span>
                                </template>
                            </template>
                        </template>
                    </td>
                    <td>
                        {{ data.date | moment("DD/MM/YYYY") }}
                    </td>
                    <td>
                        <template v-if="data.draft_user">
                            {{ data.draft_user.name }}<br>
                            {{ data.created_at | moment("HH:mm") }}
                        </template>
                        <template v-else>-</template>
                    </td>
                    <td>
                        <template v-if="data.user">
                            {{ data.user.name }}<br>
                            {{ data.updated_at | moment("HH:mm") }}
                        </template>
                        <template v-else>-</template>
                    </td>
                    <td v-if="status!=4">
                        <template v-if="data.is_credit_customer">
                            <button type="button"
                                    disabled
                                    class="btn btn-outline-secondary">
                                ดูข้อมูล
                            </button>
                        </template>
                        <template v-else>
                            <button type="button"
                                    @click="goToPayoffForm(data.id , data.payoff_status_id)"
                                    class="btn btn-outline-success">
                                ดูข้อมูล
                            </button>
                        </template>
                    </td>
                    <td v-if="status!=4">
                        <button type="button" class="btn btn-primary"
                                @click="printPayoff(data.id,data.is_credit_status)">
                            <icon name="print"></icon>
                            พิมพ์
                        </button>
                    </td>
                    <td v-if="status!=4">
                        <template v-if="data.disables">
                            <button type="button" disabled class="btn btn-outline-secondary">
                                <icon name="trash"></icon>
                                ยกเลิก
                            </button>
                        </template>
                        <template v-else>
                            <button type="button" class="btn btn-danger"
                                    @click="showDeleteModal(data.id)">
                                <icon name="trash"></icon>
                                ยกเลิก
                            </button>
                        </template>
                    </td>
                    <td v-if="status==4">
                        {{ data.remark ? data.remark : '-' }}
                    </td>
                </tr>
                </tbody>
            </table>
            <vue-pagination :pagination="dataPaginate"
                            @paginate="getPage">
            </vue-pagination>
        </div>
        <!---modal delete payoff--->
        <b-modal hide-header hide-footer ref="delete_item">
            <div style="text-align: center;">
                <h4>เพิ่มหมายเหตุการยกเลิก</h4>
                <br/>
                <div class="row form-group">
                    <div class="col-sm-4 text-right">หมายเหตุการยกเลิก</div>
                    <div class="col-sm-6">
                        <textarea class="form-control" v-model="form.remark"></textarea>
                    </div>
                </div>
                <br>
                <button @click="deleteInvoicePayoff"
                        type="button"
                        class="btn btn-success">
                    ตกลง
                </button>
                &nbsp&nbsp
                <button @click="hideDeleteModal"
                        type="button"
                        class="btn btn-outline-secondary">
                    ยกเลิก
                </button>
            </div>
        </b-modal>
        <b-modal hide-header hide-footer no-close-on-esc no-close-on-backdrop ref="loading">
            <loading :msg="msg" :status="status_loading" @submit="hideLoadingModal"></loading>
        </b-modal>
    </div>
</template>

<script>
import {mapState} from "vuex";
import Button from "bootstrap-vue/es/components/button/button";
import InputGroup from "bootstrap-vue/es/components/input-group/input-group";
import Multiselect from "vue-multiselect";
import {domain} from "../../../util/Constants";
import VuePagination from "../../Pagination";
import moment from "moment";
import DatePicker from 'vue2-datepicker'
import {canViewSuperAdmin} from "../../../util/Permissions";
import Loading from "../../Utility/Loading";

export default {
    components: {
        Loading,
        VuePagination,
        InputGroup,
        Multiselect,
        DatePicker,
        Button
    },
    name: "payoff-list",
    data() {
        return {
            msg: '',
            status_loading: '',
            status: 5,
            delete_id: "",
            page: 1,
            event_search: "",
            optionCustomer: [],
            billings: [],
            one_click: false,
            changeFormat: {
                stringify: (date) => {
                    let date_moment = moment(date).format('YYYY');
                    const year = parseInt(date_moment) + 543;
                    //console.log(moment(date).format('DD/MM/'+year));
                    return date ? moment(date).format('DD/MM/' + year) : null
                },
                parse: (value) => {
                    return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                }
            },
            lang: {
                days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                placeholder: {
                    date: 'วว/ดด/ปปปป',
                }
            },
            optionStatus: [
                {value: null, text: 'เลือกสถานะ'},
                {value: 1, text: 'รอการชำระ'},
                {value: 2, text: 'ตัดชำระเรียบร้อยแล้ว'},
                {value: 3, text: 'เครดิตเกิน'},
            ]

        }
    },
    created() {
        this.$store.dispatch("InvoicePayoff/clearSearch");
        this.$store.dispatch("InvoicePayoff/setInvoicePayoff", {
            transaction_type_id: ""
        });
        this.getCustomerAll();
    },
    computed: {
        canViewSuperAdmin,
        ...mapState({
            InvoicePayoffList: state => {
                return state.InvoicePayoff.invoicePayoffList;
            },
            search: state => {
                return state.InvoicePayoff.search
            },
            form: state => {
                return state.InvoicePayoff.form
            },
            dataPaginate: state => {
                return state.InvoicePayoff.dataPaginate
            },
            user: state => {
                return state.Auth.user
            },
        })
    },
    methods: {
        showLoadingModal() {
            this.$refs.loading.show();
        },
        hideLoadingModal() {
            this.$refs.loading.hide();
        },
        showDeleteModal(id) {
            this.delete_id = id;
            this.$store.dispatch("InvoicePayoff/showInvoicePayoff", id);
            this.$refs.delete_item.show();
        },
        hideDeleteModal() {
            this.$refs.delete_item.hide();
        },
        stopLoadingApprove() {
            let table = document.getElementById("table_payoff");
            let trs = table.getElementsByTagName("tr");
            let tds = null;
            let span = null;
            let a = null;
            for (let i = 0; i < trs.length; i++) {
                tds = trs[i].getElementsByTagName("td");
                for (let n = 0; n < tds.length; n++) {
                    span = tds[n].getElementsByClassName('for-delete');
                    if (span.length > 0) {
                        a = span[0].getElementsByTagName('a');
                        a[0].removeAttribute('class');
                    }
                }
            }
            return true;
        },
        goToPayoffForm(id, payoff_status_id) {
            // let taga = document.querySelector('#taga'+id.id);
            // let loading = document.querySelector('#loading'+id.id);

            // if (taga){
            //     taga.className += ' disabled';
            //     taga.style.display = 'none';
            //     loading.style.display = 'block';
            // }

            if (!this.one_click) {
                this.one_click = true;
                this.msg = "กำลังอัพเดตข้อมูล กรุณารอสักครู่";
                this.status_loading = 1;
                this.showLoadingModal();
                if (!payoff_status_id || payoff_status_id == 1) {
                    this.msg = 'กำลังดาวโหลดข้อมูล กรุณารอสักครู่';
                    this.status_loading = 1;
                    this.showLoadingModal();
                    this.$store.dispatch("InvoicePayoff/showInvoicePayoff", id).then(() => {
                        this.$store.dispatch("InvoicePayoff/setPayoffStatusId", payoff_status_id)
                    }).then(() => {
                        this.one_click = false;
                        // this.stopLoadingApprove();
                        // if (taga) {
                        //     taga.style.display = 'block';
                        //     loading.style.display = 'none';
                        // }
                        this.$router.push({
                            name: "invoice-payoff",
                            params: {
                                payoff_status_id: payoff_status_id,
                                id: id
                            }
                        })
                        this.hideLoadingModal();
                    });
                } else if (payoff_status_id == 2) {
                    if (!id.arrears && !id.overpay) {
                        let data = {
                            payoff_number: this.form.payoff_number,
                            date: this.form.date,
                            timer: moment().format("YYYY-MM-DD HH:mm:ss")
                        }
                        this.$store.dispatch("InvoicePayoff/approveStatus", {
                            id: id.id,
                            data: data
                        }).then(payoff => {
                            if (payoff) {
                                // this.one_click = false;
                                // if (taga) {
                                //     taga.style.display = 'block';
                                //     loading.style.display = 'none';
                                // }
                                this.saveAndPrint(payoff);
                            } else {
                                this.msg = "อัพเดตข้อมูลไม่สำเร็จ";
                                this.status_loading = 3;
                            }
                            // this.one_click = false;
                            // this.hideLoadingModal();
                        }).catch(() => {
                            this.one_click = false;
                            // this.stopLoadingApprove();
                            // if (taga) {
                            //     taga.style.display = 'block';
                            //     loading.style.display = 'none';
                            // }
                            this.msg = "อัพเดตข้อมูลไม่สำเร็จ";
                            this.status_loading = 3;
                        });
                    } else {
                        this.$store.dispatch("InvoicePayoff/showInvoicePayoff", id.id).then(() => {
                            this.$store.dispatch("InvoicePayoff/setPayoffStatusId", payoff_status_id)
                        }).then(() => {
                            this.one_click = false;
                            // this.stopLoadingApprove();
                            // if (taga) {
                            //     taga.style.display = 'block';
                            //     loading.style.display = 'none';
                            // }
                            this.$router.push({
                                name: "invoice-payoff",
                                params: {
                                    payoff_status_id: payoff_status_id,
                                    id: id.id
                                }
                            })
                            this.hideLoadingModal();
                        });
                    }
                }
            }
        },
        saveAndPrint(id) {
            this.$store.dispatch("InvoicePayoff/printInvoicePayoffById", {
                id,
                user_id: this.user.id,
            }).then(url => {
                if (url) {
                    this.one_click = false;
                    this.search.invoice_id = '';
                    this.search.billing = '';
                    window.open(url, '_blank');
                    this.$store.dispatch("InvoicePayoff/setInvoicePayoff", {
                        transaction_type_id: ""
                    }).then(() => {
                        this.one_click = false;
                        this.hideLoadingModal();
                        // this.stopLoadingApprove();
                    });
                } else {
                    this.msg = 'ไม่สามารถพิมพ์ RV ได้';
                    this.status_loading = 3;
                    this.one_click = false;
                    // this.stopLoadingApprove();
                }
            }).catch(() => {
                this.msg = 'ไม่สามารถพิมพ์ RV ได้';
                this.status_loading = 3;
                this.one_click = false;
                // this.stopLoadingApprove();
            })
        },
        getInvoicePayoffByTransactionType(status) {
            this.status = status;
            //console.log("status :",status);
            this.showLoadingModal();
            this.msg = "กำลังค้นหาข้อมูล";
            this.status_loading = 1;
            this.$store.dispatch("InvoicePayoff/setInvoicePayoff", {
                transaction_type_id: status
            }).then(() => {
                this.hideLoadingModal();
            })
        },
        getCustomerAll() {
            this.$store.dispatch("Customer/setAllCustomer").then(res => {
                this.optionCustomer = res;
            });
        },
        deleteInvoicePayoff() {
            if (!this.form.remark) {
                alert("กรุณาใส่หมายเหตุ")
            } else {
                let data = {
                    page: 1,
                    id: this.delete_id,
                    remark: this.form.remark
                };

                this.$store.dispatch("InvoicePayoff/deleteInvoicePayoff", data).then(() => {
                    this.status = 4;
                    this.$store.dispatch("InvoicePayoff/setInvoicePayoff", {
                        transaction_type_id: 4
                    })
                });
                this.hideDeleteModal()
            }
        },
        printCustomerOverpay() {
            let start_date = "";
            let end_date = "";
            if (this.search.date.length > 0 && this.search.date[0]) {
                start_date = moment(this.search.date[0]).format("YYYY-MM-DD");
                end_date = moment(this.search.date[1]).format("YYYY-MM-DD");
            } else {
                this.search.date = [];
            }
            let search = {
                invoice_id: this.search.invoice_id,
                customer_id: this.search.customer,
                start_date: start_date,
                end_date: end_date,
                transaction_type_id: this.status,
                rv_number: this.search.rv_number,
                rv_status: this.search.rv_status,
                billing_id: this.search.billing,
                amount: this.search.amount
            };
            let url = domain + `/customer_overpay_excel?start_date=${search.start_date}&end_date=${search.end_date}`

            window.open(url, '_blank')
        },
        searchPayoff(page) {
            this.event_search = true;
            let start_date = "";
            let end_date = "";
            if (this.search.date.length > 0 && this.search.date[0]) {
                start_date = moment(this.search.date[0]).format("YYYY-MM-DD");
                end_date = moment(this.search.date[1]).format("YYYY-MM-DD");
            } else {
                this.search.date = [];
            }
            let search = {
                // invoice_id : this.search.invoice ? this.search.invoice.id : "",
                invoice_id: this.search.invoice_id,
                customer_id: this.search.customer,
                start_date: start_date,
                end_date: end_date,
                transaction_type_id: this.status,
                rv_number: this.search.rv_number,
                rv_status: this.search.rv_status,
                billing_id: this.search.billing,
                amount: this.search.amount
            };
            this.showLoadingModal();
            this.msg = "กำลังค้นหาข้อมูล";
            this.status_loading = 1;
            this.$store.dispatch("InvoicePayoff/searchPayoff", {
                page: page,
                data: search
            }).then(() => {
                this.hideLoadingModal();
            }).catch(() => {
                this.showLoadingModal();
                this.msg = "ค้นหาข้อมูลไม่สำเร็จ";
                this.status_loading = 3;
            });
        },
        printPayoffwithSearch() {
            this.event_search = true;
            let start_date = "";
            let end_date = "";
            if (this.search.date.length > 0 && moment(this.search.date[1]).diff(moment(this.search.date[0]), 'days') + 1 > 10 && !this.search.customer) {
                alert('กรุณาเลือกไม่เกิน 10 วัน ถ้าต้องการให้เลือกเกินได้กรุณาใส่ที่ช่องหาค้นลูกค้าด้วย')
            } else if (this.search.date.length > 0 && this.search.date[0]) {
                start_date = moment(this.search.date[0]).format("YYYY-MM-DD");
                end_date = moment(this.search.date[1]).format("YYYY-MM-DD");
                let search = {
                    invoice_id: this.search.invoice_id ? this.search.invoice_id : '',
                    customer_id: this.search.customer ? this.search.customer : '',
                    start_date: start_date,
                    end_date: end_date,
                    transaction_type_id: this.status ? this.status : '',
                    rv_number: this.search.rv_number ? this.search.rv_number : '',
                    rv_status: this.search.rv_status ? this.search.rv_status : '',
                    billing_id: this.search.billing ? this.search.billing : '',
                    amount: this.search.amount ? this.search.amount : ''
                };
                // this.showLoadingModal();
                // this.msg = "กำลังค้นหาข้อมูล";
                // this.status_loading = 1;
                window.open(
                    `${domain}/payoff_print?invoice_id=${search.invoice_id}
                        &customer_id=${search.customer_id}
                        &start_date=${search.start_date}
                        &end_date=${search.end_date}
                        &transaction_type_id=${search.transaction_type_id}
                        &rv_number=${search.rv_number}
                        &rv_status=${search.rv_status}
                        &billing_id=${search.billing_id}
                        &amount=${search.amount}`
                );
            } else {
                alert('กรุณาเลือกช่วงวันที่')
            }
        },
        printPayoffwithSearchDriver() {
            this.event_search = true;
            let start_date = "";
            let end_date = "";
            if (this.search.date.length > 0 && moment(this.search.date[1]).diff(moment(this.search.date[0]), 'days') + 1 > 10 && !this.search.customer) {
                alert('กรุณาเลือกไม่เกิน 10 วัน ถ้าต้องการให้เลือกเกินได้กรุณาใส่ที่ช่องหาค้นลูกค้าด้วย')
            } else if (this.search.date.length > 0 && this.search.date[0]) {
                start_date = moment(this.search.date[0]).format("YYYY-MM-DD");
                end_date = moment(this.search.date[1]).format("YYYY-MM-DD");
                let search = {
                    invoice_id: this.search.invoice_id ? this.search.invoice_id : '',
                    customer_id: this.search.customer ? this.search.customer : '',
                    start_date: start_date,
                    end_date: end_date,
                    transaction_type_id: this.status ? this.status : '',
                    rv_number: this.search.rv_number ? this.search.rv_number : '',
                    rv_status: this.search.rv_status ? this.search.rv_status : '',
                    billing_id: this.search.billing ? this.search.billing : '',
                    amount: this.search.amount ? this.search.amount : ''
                };
                // this.showLoadingModal();
                // this.msg = "กำลังค้นหาข้อมูล";
                // this.status_loading = 1;
                window.open(
                    `${domain}/payoff_print_driver?invoice_id=${search.invoice_id}
                        &customer_id=${search.customer_id}
                        &start_date=${search.start_date}
                        &end_date=${search.end_date}
                        &transaction_type_id=${search.transaction_type_id}
                        &rv_number=${search.rv_number}
                        &rv_status=${search.rv_status}
                        &billing_id=${search.billing_id}
                        &amount=${search.amount}`
                );
            } else {
                alert('กรุณาเลือกช่วงวันที่')
            }
        },
        //save print rv to print
        printPayoff(id) {
            this.showLoadingModal();
            this.msg = "กำลังดาวโหลดข้อมูล";
            this.status_loading = 1;
            this.$store.dispatch("InvoicePayoff/printInvoicePayoffById", {
                id,
                user_id: this.user.id,
            }).then(url => {
                if (url) {
                    window.open(url, '_blank');
                    this.hideLoadingModal();
                } else {
                    this.showLoadingModal();
                    this.msg = "ไม่สามารถพิมพ์ RV ได้";
                    this.status_loading = 3;
                }
            }).catch(() => {
                this.showLoadingModal();
                this.msg = "ไม่สามารถพิมพ์ RV ได้";
                this.status_loading = 3;
            })
        },
        onPayoff() {
            this.$store.dispatch("InvoicePayoff/clearDataForm");
            this.$router.push({name: "invoice-payoff"});
        },
        getPage() {
            this.page = this.dataPaginate.current_page;
            if (this.event_search) {
                this.searchPayoff(this.page);
            } else {
                this.$store.dispatch("InvoicePayoff/setInvoicePayoff", {
                    page: this.page,
                    transaction_type_id: this.status
                });
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.navbar-light .navbar-nav .show > .nav-link,
.navbar-light .navbar-nav .active > .nav-link,
.navbar-light .navbar-nav .nav-link.show,
.navbar-light .navbar-nav .nav-link.active {
    color: black;
    font-weight: bold;
    background-color: #F5C157;
    border-radius: 3px;
}

.margin {
    margin: 5px;
}

.navbar-nav .nav-link {
    color: black;
}

a.disabled {
    pointer-events: none;
    cursor: default;
}
</style>
